// ISO 3166-1 alpha-2 country codes offered at signup / profile (EU/EEA + UK/CH + common).
// Display names are localized at render time via Intl.DisplayNames.
export const COUNTRY_CODES = [
  "FR", "BE", "LU", "NL", "DE", "ES", "IT", "PT", "GB", "IE", "AT", "CH",
  "DK", "SE", "NO", "FI", "IS", "PL", "CZ", "SK", "HU", "RO", "BG", "HR",
  "SI", "EE", "LV", "LT", "GR", "CY", "MT", "US", "CA", "MA", "DZ", "TN",
  "SN", "CI", "CM", "TR", "JP", "BR", "AR",
];

export function countryOptions(lang) {
  const dn = new Intl.DisplayNames([lang === "fr" ? "fr" : "en"], { type: "region" });
  return COUNTRY_CODES.map((code) => ({ code, name: dn.of(code) || code }))
    .sort((a, b) => a.name.localeCompare(b.name, lang === "fr" ? "fr" : "en"));
}
